import React, { HTMLAttributes, ChangeEvent } from 'react';
import { HorizontalSeparator } from '../Separator';
import { TCheckBoxLabel } from './types';

const generateInputId = (label: string, index: number): string =>
  `default-checkbox-${label.replace(/\s/g, '')}-${index}`;
interface CheckboxInputProps extends HTMLAttributes<HTMLDivElement> {
  options: TCheckBoxLabel[];
  onCheckboxClick: (option: TCheckBoxLabel, isChecked: boolean) => void;
  checkedOptions: (string | number)[];
  onSelectAllToggle: (isSelectedAll: boolean) => void;
  hideSelectAll?: boolean;
}

const CheckboxInput: React.FC<CheckboxInputProps> = ({
  options,
  checkedOptions,
  onCheckboxClick,
  onSelectAllToggle,
  hideSelectAll = false
}) => {
  const handleSelectAllToggle = () => {
    onSelectAllToggle(checkedOptions.length === options.length);
  };

  const handleOnChange = (option: TCheckBoxLabel, event: ChangeEvent<HTMLInputElement>) => {
    onCheckboxClick(option, event.currentTarget.checked);
  };

  return (
    <div>
      {!hideSelectAll && (
        <>
          <div className="py-2 pl-3">
            <a onClick={handleSelectAllToggle} className="text-emerge-navy-2 cursor-pointer">
              {checkedOptions.length === options.length ? 'Unselect all' : 'Select all'}
            </a>
          </div>
          <HorizontalSeparator />
        </>
      )}
      <div className="flex flex-col mb-4">
        {options.map((option, index) => {
          const inputId = generateInputId(option.label, index);
          return (
            <div key={index}>
              <div className="flex flex-row justify-between items-center">
                <label
                  htmlFor={inputId}
                  className="ms-2 text-xs font-medium text-dark-navy-30 flex flex-row gap-x-2 py-2">
                  <div>{option.icon}</div>
                  <div className="flex flex-col justify-center">
                    {option.label}
                    {option.labelDescription ? (
                      <span className="text-emerge-navy-2 text-xs">{option.labelDescription}</span>
                    ) : null}
                  </div>
                </label>
                <input
                  id={inputId}
                  type="checkbox"
                  onChange={(e) => handleOnChange(option, e)}
                  value={option.value}
                  checked={Boolean(checkedOptions.find((el) => el === option.value))}
                  className="me-1 w-4 h-4 text-dark-navy-30 bg-aux-lightgray border-aux-gray rounded focus:ring-transparent cursor-pointer"
                />
              </div>
              <HorizontalSeparator />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CheckboxInput;
